module.exports = __webpack_public_path__ + "img/om.7809d37a.svg";